/** Public marketing copy for /receptionist (non-technical). */

export const receptionistContent = {
  eyebrow: "AI phone receptionist",
  title: "Every call answered. Every lead captured.",
  lead:
    "Give your business a real phone number that picks up day or night - with a natural voice on the line and a live dashboard so you always know who called and what happened next.",
  heroPoints: [
    "Works with your existing business phone line",
    "Sounds like a person, not a robot menu",
    "See calls update in real time while they happen",
  ],
  features: [
    {
      id: "phone",
      title: "Your number, always on",
      body:
        "Callers reach a dedicated business line powered by proven phone technology. The assistant greets them, learns what they need, and routes or books - so voicemail stops eating your opportunities.",
      icon: "phone",
    },
    {
      id: "voice",
      title: "A voice that fits your brand",
      body:
        "Choose how your assistant sounds - from warm and professional to crisp and direct. Multiple languages help you welcome callers in the language they prefer.",
      icon: "voice",
    },
    {
      id: "dashboard",
      title: "Live command center",
      body:
        "Watch active calls, see who is on the line, read what was said, and review leads, callbacks, and handoffs to your team - all in one dashboard that refreshes as the conversation moves.",
      icon: "dashboard",
    },
    {
      id: "deploy",
      title: "Cloud or on your premises",
      body:
        "Run in the cloud for simple setup, or on an edge device at your location when you want voice and data closer to home. We help you pick what fits your security and ops.",
      icon: "deploy",
    },
  ],
  integrations: {
    title: "More connections on the way",
    body:
      "Calendar booking, CRM handoffs, and other business tools are rolling out next - so the assistant does more than talk; it plugs into how you already work.",
  },
  dashboard: {
    title: "What you see while calls are happening",
    subtitle:
      "Your team gets a clear picture - not a black box. Sample view below mirrors the live receptionist dashboard.",
    businessName: "Your business",
    metrics: {
      totalCalls: "128",
      activeNow: "2",
      lastUpdate: "Just now",
    },
    activeCalls: [
      { id: "Call …4821", state: "Taking details", snippet: "Asking about same-day service" },
      { id: "Call …9103", state: "Routing", snippet: "Wants to speak with billing" },
    ],
    recent: [
      {
        id: "Call …7712",
        state: "Wrapped up",
        outcome: "Lead captured",
        response: "Scheduled callback for Tuesday",
        time: "2 min ago",
      },
      {
        id: "Call …6604",
        state: "Handed off",
        outcome: "Live person",
        response: "Transferred to front desk",
        time: "18 min ago",
      },
      {
        id: "Call …5590",
        state: "Wrapped up",
        outcome: "FAQ answered",
        response: "Hours and parking info",
        time: "41 min ago",
      },
    ],
    liveBadge: "Live",
  },
  desktopTieIn: {
    title: "Same assistant, desk and phone",
    body:
      "The voice you hear on your computer is the same stack behind your business line - one brain, two ways to reach your customers. Ask questions at your desk; callers get the same quality on the phone.",
  },
  cta: {
    primary: "Talk to us about your line",
    secondary: "View pricing",
  },
};
